<div *ngIf="!showList" class="application-select">{{applicationTitle}}</div>

<div *ngIf="showList" class="application-select dropdown d-inline-block">    
  <a      
    class="dropdown-toggle no-caret text-white" 
    id="application-select-menu" 
    data-toggle="dropdown" 
    aria-haspopup="true" 
    aria-expanded="false" 
    role="button"
    data-testid="application-select-menu">
    <span>{{applicationTitle}}</span>      
    <span class="ml-1 fa fa-caret-down"></span>
  </a>

  <div class="dropdown-menu mt-0 rounded-0 p-0 box-shadow" aria-labelledby="application-select-menu">
    <a class="dropdown-item mt-1" routerLink="/fleet-manager" *ngIf="canAccessFleetManager" routerLinkActive #fleetManagerRLA="routerLinkActive" [class.active]="fleetManagerRLA.isActive" data-testid="application-select-fleet-manager">
      <i class="fa mr-2" [ngClass]="fleetManagerRLA.isActive ? 'fa-check-circle' : 'fa-circle-o'"></i>
      Fleet Manager
    </a>
    <a class="dropdown-item" routerLink="/portal" *ngIf="canAccessPortal" routerLinkActive #portalRLA="routerLinkActive" [class.active]="portalRLA.isActive" data-testid="application-select-portal">
      <i class="fa mr-2" [ngClass]="portalRLA.isActive ? 'fa-check-circle' : 'fa-circle-o'"></i>
      Portal
    </a>
    <a class="dropdown-item mb-1" routerLink="/carrier" *ngIf="canAccessCarrier" routerLinkActive #carrierRLA="routerLinkActive" [class.active]="carrierRLA.isActive" data-testid="application-select-carrier">
      <i class="fa mr-2" [ngClass]="carrierRLA.isActive ? 'fa-check-circle' : 'fa-circle-o'"></i>
      Carrier
    </a>
    <a class="dropdown-item mb-1" routerLink="/developer" *ngIf="canAccessDeveloper" routerLinkActive #developerRLA="routerLinkActive" [class.active]="developerRLA.isActive" data-testid="application-select-developer">
      <i class="fa mr-2" [ngClass]="developerRLA.isActive ? 'fa-check-circle' : 'fa-circle-o'"></i>
      Developer
    </a>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/core/components/header/application-select/application-select.component.html